export class PractitionerFavoriteReq {
  userId: number;
  type: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  pageIndex: number;
  itemsCount: number;
  specialty: string;
  criteria: string;
  parenttype: string = "";
  healthOrganizationId: number;
  employerId: number;
}

export interface PractitionerFavoriteRes {
  id: number;
  practitionerId: number;
  practitionerNPI: string;
  practitionerName: string;
  practitionerTitle: string;
  specialty: string;
  photoUrl: string;
  gender: string;
  birthDate: string;
  primaryPhoneNumber: string;
  faxNumber: string;
  addresses: FavoriteAddressRes[];
}

export interface FavoriteAddressRes {
  address1: string;
  address2: string;
  city: string;
  state: string;
  cleanZipCode: string;
}
